import { render } from "./HighlightedTopics.vue?vue&type=template&id=9c9f69f2"
import script from "./HighlightedTopics.vue?vue&type=script&lang=js"
export * from "./HighlightedTopics.vue?vue&type=script&lang=js"

import "./HighlightedTopics.vue?vue&type=style&index=0&id=9c9f69f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__